import { render, staticRenderFns } from "./GuardiansWithChildren.vue?vue&type=template&id=05406f90"
import script from "./GuardiansWithChildren.vue?vue&type=script&lang=js"
export * from "./GuardiansWithChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports